import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API,
});

// Attach token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('lavaporcar_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ==================== Auth ====================
export const loginAdmin = async (password) => {
  const { data } = await apiClient.post('/auth/login', { password });
  localStorage.setItem('lavaporcar_admin_token', data.access_token);
  return data;
};

export const verifyAdmin = async () => {
  const { data } = await apiClient.get('/auth/verify');
  return data;
};

export const logoutAdmin = () => {
  localStorage.removeItem('lavaporcar_admin_token');
};

// ==================== Gallery ====================
export const getGallery = async () => {
  const { data } = await apiClient.get('/gallery');
  return data;
};

export const createGalleryItem = async (item) => {
  const { data } = await apiClient.post('/gallery', item);
  return data;
};

export const updateGalleryItem = async (id, item) => {
  const { data } = await apiClient.put(`/gallery/${id}`, item);
  return data;
};

export const deleteGalleryItem = async (id) => {
  const { data } = await apiClient.delete(`/gallery/${id}`);
  return data;
};

// ==================== Videos ====================
export const getVideos = async () => {
  const { data } = await apiClient.get('/videos');
  return data;
};

export const createVideo = async (item) => {
  const { data } = await apiClient.post('/videos', item);
  return data;
};

export const updateVideo = async (id, item) => {
  const { data } = await apiClient.put(`/videos/${id}`, item);
  return data;
};

export const deleteVideo = async (id) => {
  const { data } = await apiClient.delete(`/videos/${id}`);
  return data;
};

// ==================== Before/After ====================
export const getBeforeAfter = async () => {
  const { data } = await apiClient.get('/before-after');
  return data;
};

export const createBeforeAfter = async (item) => {
  const { data } = await apiClient.post('/before-after', item);
  return data;
};

export const updateBeforeAfter = async (id, item) => {
  const { data } = await apiClient.put(`/before-after/${id}`, item);
  return data;
};

export const deleteBeforeAfter = async (id) => {
  const { data } = await apiClient.delete(`/before-after/${id}`);
  return data;
};

// ==================== Contact ====================
export const getContactMessages = async () => {
  const { data } = await apiClient.get('/contact');
  return data;
};

export default apiClient;
